document.addEventListener("DOMContentLoaded", (event) => {
    const tableOfContents = document.querySelector(".ns-table-of-contents");
    if (!tableOfContents) {
        return;
    }
    const prevSection = tableOfContents.previousElementSibling;
    const titlesList = tableOfContents.querySelector(".ns-table-of-contents__items-list");
    const titles = document.querySelectorAll(".ns-content h2:not(.ns-table-of-contents__escape-title)");
    titles.forEach((item, index) => {
        const id = `ns-table-of-contents-title-${index}`;
        item.id = id;
        let titleLink = document.createElement('a');
        titleLink.href = `#${id}`;
        titleLink.dataset.anchorId = id;
        titleLink.textContent = item.textContent;
        titlesList.appendChild(titleLink);
    })

    titles.forEach((title) => {
        let observer = new IntersectionObserver(inView);
        observer.observe(title);

    });

    function inView(entries, observer){
        entries.forEach((entry) => {
            if(entry.isIntersecting){
                document.querySelectorAll(".ns-table-of-contents__items-list a").forEach((link) => {
                    link.classList.remove("active");
                });
                document.querySelector(`a[href="#${entry.target.id}"]`).classList.add("active");
            }
        });
    }

    function updateTableOfContentsVerticalPosition(){
        const topOffset = (prevSection.offsetTop + prevSection.offsetHeight);
        if(window.scrollY + prevSection.offsetTop * 2 - prevSection.offsetTop < topOffset){
            tableOfContents.style.top = `${topOffset - window.scrollY}px`;
        }
        else{
            tableOfContents.style.top = `${prevSection.offsetTop}px`;
        }
    }
    function updateTableOfContentsHorizontalPosition(){
        tableOfContents.classList.add("float-mode");
        if(tableOfContents.offsetLeft < 20){
            tableOfContents.classList.remove("float-mode");
        }
        updateTableOfContentsVerticalPosition();
    }
    updateTableOfContentsHorizontalPosition();
    window.addEventListener("resize", updateTableOfContentsHorizontalPosition, false);
    window.addEventListener("scroll", updateTableOfContentsVerticalPosition, false);

    const anchors = tableOfContents.querySelectorAll("a");
    anchors.forEach((anchor) => {
        anchor.onclick = (e)=>{
            e.preventDefault();
            window.scrollTo({
                top: document.getElementById(anchor.dataset.anchorId).offsetTop - 100,
                behavior: "smooth",
            });
        };
        anchor.onmouseenter = () => {
            anchor.classList.add("hover");
        }
        anchor.onmouseleave = () => {
            anchor.classList.remove("hover");
        }
    });
});
